import { render, staticRenderFns } from "./CharacterDetail.vue?vue&type=template&id=0750df5b&scoped=true"
import script from "./CharacterDetail.vue?vue&type=script&lang=ts"
export * from "./CharacterDetail.vue?vue&type=script&lang=ts"
import style0 from "./CharacterDetail.vue?vue&type=style&index=0&id=0750df5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0750df5b",
  null
  
)

export default component.exports